module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="gut-check-step">\n    <div class="gut-check">\n        <div class="gut-check__header"></div>\n    </div>\n\n    <div class="gut-check__region"></div>\n</div>\n';

}
return __p
}